import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";

Vue.config.productionTip = false;
import VueProgressBar from "vue-progressbar";
import progressBarOptions from "./progress.config";
Vue.use(VueProgressBar, progressBarOptions);

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import VueMask from "v-mask";
Vue.use(VueMask);

import VeeValidate from "vee-validate";
import veeCustomMessages from "./validation.config";
Vue.use(VeeValidate, {
    dictionary: veeCustomMessages,
    fieldsBagName: "veeFields",
});

import moment from "moment";
Vue.filter("formatDate", (value) => {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
    }
});

import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
